import { IActivity } from '../../../../App/store/features/activity/interface/IActivityList'
import { Person } from '../../../../App/store/features/person/IPerson'
import { IAddedActivity } from '../AddActivityViewSwitch/IAddActivity'

export const activityToAddedActivity = (
  activity: IActivity,
  activityList: IActivity[],
  defaultPersonUuids: string[],
  personList: Person[],
): IAddedActivity => {
  const missingNumberOfPersonUuids: number =
    activity.numberOfPersons - defaultPersonUuids.length

  const completeDefaultPersonUuids = (): string[] => {
    if (missingNumberOfPersonUuids > 0) {
      const unSelectedPersons: Person[] = personList.filter(
        person => !defaultPersonUuids.includes(person.personUuid),
      )
      const missingPersonUuids: string[] = Array.from(
        Array(missingNumberOfPersonUuids).keys(),
      ).map(missingNumber => unSelectedPersons[missingNumber].personUuid)
      return [...defaultPersonUuids, ...missingPersonUuids]
    }
    return Array.from(Array(activity.numberOfPersons).keys()).map(
      indexNumber => personList[indexNumber].personUuid,
    )
  }

  const completedPersonUuids: string[] =
    missingNumberOfPersonUuids === 0
      ? defaultPersonUuids
      : completeDefaultPersonUuids()

  return {
    activity,
    isLocked: false,
    personUuids: completedPersonUuids,
    appointmentActivityUuid: null,
    appointmentActivityId: null,
  }
}
